// This is used to determine if an element has been scrolled into view.
// Used specifically for the history line.
import $ from 'jquery';

$.fn.isInViewport = function ({ bottom = 0 }) {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop + bottom < viewportBottom;
};

$(function () {
  var scroll = window.requestAnimationFrame ||
    function (callback) { window.setTimeout(callback, 1000 / 60) };

  var elementsToShow = document.getElementsByClassName('nosotros-history__history-item');

  function loop() {

    for (var i = 0; i < elementsToShow.length; i++) {
      var element = elementsToShow.item(i);

      if ($(element).isInViewport({ bottom: 0 })) {
        element.classList.add('is-visible');
      }
    }

    scroll(loop);
  }

  loop();
});

function numberWithThousands(x) {
  // convert to char array
  var charArray = x.toString().split('');

  // reverse the array
  charArray.reverse();

  // convert to string
  var result = charArray.join('');

  // split into groups of 3
  var result = result.match(/.{1,3}/g).join('.');

  // reverse the result
  result = result.split('').reverse().join('');

  return result;
}

$(function nosotrosAnimateNumbers() {

  var scroll = window.requestAnimationFrame ||
    function (callback) { window.setTimeout(callback, 1000 / 60) };

  let hasAnimated = false;
  function loop() {
    if (hasAnimated) return;

    if ($('#nosotros-metrics').isInViewport({ bottom: 150 })) {
      hasAnimated = true;
      animateNumbers($('#nosotros-metrics'));
    }

    scroll(loop);
  }
  loop();

  let hasAnimatedMobile = false;
  function loopMobile() {
    if (hasAnimatedMobile) return;

    if ($('#nosotros-metrics-mobile').isInViewport({ bottom: 150 })) {
      hasAnimatedMobile = true;
      animateNumbers($('#nosotros-metrics-mobile'));
    }

    scroll(loopMobile);
  }

  loopMobile();

  function animateNumbers($parent) {
    const duration = 1000;

    $parent.find('.nosotros-metric__number').addClass('active');

    $({ val: 170000 }).animate({ val: 180000 }, {
      duration,
      step: function (val) {
        $parent.find('.nosotros-metric__number1').text(`${numberWithThousands(val.toFixed(0))}+`);
      }
    });

    $({ val: 6400 }).animate({ val: 6500 }, {
      duration,
      step: function (val) {
        $parent.find('.nosotros-metric__number2').text(`${numberWithThousands(val.toFixed(0))}+`);
      }
    });

    $({ val: 85 }).animate({ val: 99.15 }, {
      duration,
      step: function (val) {
        $parent.find('.nosotros-metric__number3').text(`${val.toFixed(2).replace('.', ',')}%`);
      }
    });

    $({ val: 1400 }).animate({ val: 1500 }, {
      duration,
      step: function (val) {
        $parent.find('.nosotros-metric__number4').text(`${numberWithThousands(val.toFixed(0))}+`);
      }
    });

  }

});
